'use client';

import type { Step } from '@/components/wizard/Step';
import { Wizard } from '@/components/wizard/Wizard';
import { useWorkspace } from '@/contexts/useWorkspace';

import { AddExistingPrivateLink } from './addExistingPrivateLink';
import type { RestoreMongoAtlasPrivateLinkWizardState } from './restoreMongoAtlasPrivateLinkWizardState';

const addExistingStep: Step<RestoreMongoAtlasPrivateLinkWizardState> = {
  id: 'add_existing_private_link',
  Component: AddExistingPrivateLink,
  nonReturnable: true,
};

export function RestoreMongoAtlasPrivateLinkWizard({
  atlasProjectId,
  cloudAccountId,
  onCreated,
}: {
  atlasProjectId: string;
  cloudAccountId: string;
  onCreated: () => Promise<void>;
}) {
  const { rightPanel } = useWorkspace();

  const onFinish = async () => {
    await onCreated();
    return true;
  };

  return (
    <Wizard<RestoreMongoAtlasPrivateLinkWizardState>
      hideCloseButton={false}
      onAbort={() => rightPanel.setIsOpen(false)}
      hideBackArrow={true}
      onFinish={onFinish}
      flow={[addExistingStep]}
      title='Add Existing Private Link'
      initialState={{
        atlasProjectId,
        cloudAccountId,
        region: '',
        vpcEndpointId: '',
      }}
    />
  );
}
